import React, { useState, useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import { Button, Chip, Typography, Box } from '@mui/material';
import { KinkSelector } from './KinkSelector';

export const KinkNode = ({ data, selected, id }) => {
  const [isSelectorOpen, setIsSelectorOpen] = useState(false);

  const handleKinkSelect = useCallback((kink) => {
    data.onChange?.({ 
      kinkId: kink.id, 
      kinkName: kink.name, 
      kinkInstruction: kink.instruction 
    });
    setIsSelectorOpen(false);
  }, [data]);

  const handleKinkRemove = useCallback(() => {
    data.onChange?.({ kinkId: null, kinkName: null, kinkInstruction: null });
  }, [data]);

  return (
    <div className="react-flow__node-default" style={{ minWidth: '200px', width: 'auto' }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ 
          left: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="condition-label">
        <label style={{ display: 'block' }}>Kink</label>
      </div>

      <div style={{ padding: 20, paddingTop: 0 }}>
        {data.kinkId ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start', width: '100%' }}>
            <Chip 
              label={data.kinkName} 
              onDelete={handleKinkRemove}
              color="primary" 
              sx={{ maxWidth: '100%' }}
            />
            {data.kinkInstruction && (
              <Box 
                sx={{ 
                  width: '100%',
                  mt: 1,
                  p: 1.5,
                  backgroundColor: 'rgba(0, 0, 0, 0.05)',
                  borderRadius: 1,
                  border: '1px solid rgba(0, 0, 0, 0.1)',
                  maxWidth: '100%',
                  boxSizing: 'border-box'
                }}
              >
                <Typography 
                  variant="body2" 
                  component="div"
                  sx={{ 
                    color: 'text.secondary',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    fontSize: '0.875rem',
                    lineHeight: 1.5,
                    overflowWrap: 'break-word'
                  }}
                >
                  {data.kinkInstruction}
                </Typography>
              </Box>
            )}
          </div>
        ) : (
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => setIsSelectorOpen(true)}
            fullWidth
          >
            Select kink
          </Button>
        )}
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="true"
        style={{
          right: 0,
          top: data.kinkId ? '50%' : '64%',
          transform: 'translateY(-50%)'
        }}
      />

      <KinkSelector
        open={isSelectorOpen}
        onClose={() => setIsSelectorOpen(false)}
        onSelect={handleKinkSelect}
      />
    </div>
  );
};

